import { VASReportResponse, DataStream } from '../../interfaces';

export enum VASProcessedTypes {
  VIEW_VAS_OVERVIEW_REQUEST = '@@vas/VIEW_VAS_OVERVIEW_REQUEST',
  VIEW_VAS_OVERVIEW_SUCCESS = '@@vas/VIEW_VAS_OVERVIEW_SUCCESS',
  VIEW_VAS_OVERVIEW_FAILURE = '@@vas/VIEW_VAS_OVERVIEW_FAILURE',
  EXPORT_VIEW_VAS_OVERVIEW_REQUEST = '@@vas/EXPORT_VIEW_VAS_OVERVIEW_REQUEST',
  EXPORT_VIEW_VAS_OVERVIEW_SUCCESS = '@@vas/EXPORT_VIEW_VAS_OVERVIEW_SUCCESS',
  EXPORT_VIEW_VAS_OVERVIEW_FAILURE = '@@vas/EXPORT_VIEW_VAS_OVERVIEW_FAILURE',
  CLEAR_VAS = '@@vas/CLEAR_VAS',
}

export type VASProcessedState = {
  readonly vas: VASReportResponse | null;
  readonly loading: boolean;
  readonly vasError: any;
  readonly exportError: any;
  readonly vasExportError: any;
  readonly isExporting: boolean;
  readonly isExportSuccess: boolean;
  readonly isExportError: boolean;
  readonly exportStream: DataStream | undefined;
};
